import React from "react";
import styles from "./Popup.module.css";
import Button from "../Button";

interface PopupProps {
  message: string;
  type: "confirm" | "success";
  onConfirm?: () => void;
  onCancel?: () => void;
  onClose?: () => void;
}

const Popup: React.FC<PopupProps> = ({ message, type, onConfirm, onCancel, onClose }) => {
  return (
    <div className={styles.overlay}>
      <div className={styles.popup}>
        {type === "success" && (
          <button className={styles.closeButton} onClick={onClose}>
            ×
          </button>
        )}

        <p>{message}</p>

        {type === "confirm" && (
          <div className={styles.buttons}>
            <Button onClick={onConfirm}>Да</Button>
            <Button onClick={onCancel}>Нет</Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Popup;
